import React, { useState } from "react";
import { useEffect } from "react";

const Checkbox = ({
  item,
  includeList,
  identifier,
  otherItem,
  size = "20",
  background,
}) => {
  const [selected, setSelected] = useState(false);

  useEffect(() => {
    if (identifier && !includeList) {
      setSelected(item[identifier] == otherItem[identifier]);
    } else if (identifier && includeList) {
      setSelected(
        includeList.map((i) => i[identifier]).includes(item[identifier])
      );
    } else if (!identifier && !includeList) {
      setSelected(item == otherItem);
    } else if (!identifier && includeList) {
      setSelected(includeList.includes(item));
    }
  }, [item, includeList, otherItem]);
  return (
    <img
      src={
        selected
          ? "/icons/icon_checkbox_checked.png"
          : "/icons/icon_checkbox_unchecked.png"
      }
      style={{
        objectFit: "contain",
        height: `${size}px`,
        backgroundColor: background,
      }}
    />
  );
};

export default Checkbox;
